module.exports = "/assets/b32229e7d6dba9b9af9a3f680735900d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/YQ.png
// module id = 2039
// module chunks = 0